export default {
    methods: {
        /**
         * 全局picker组件的搜索逻辑 使用这个方法必须保证所有的数据结构都和现有的数据结构一致
         * @param text
         * @param deploy 数据源和用于展示的过滤数据源
         * @param key 搜索的key 没有就说明源数据不是两层
         */
        pickerSearch(text, deploy, key) {
            deploy.filteredData = deploy.data.filter(item => {
                return key ? item[key].indexOf(text) !== -1 : item.indexOf(text) !== -1
            })
        },
        // 使用这个必须保证所有的数据结构都和现有的数据结构一致
        popupSubmit(field, props) {
            const item = this.$refs[field].getValues()[0]
            this.$set(this[field], 'show', false)
            this.$set(this.formData, field, item[props.value])
        },

    }
}